import { render, staticRenderFns } from "./RegistryEntityProfile.vue?vue&type=template&id=9c417fbc"
import script from "./RegistryEntityProfile.vue?vue&type=script&lang=js"
export * from "./RegistryEntityProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9c417fbc')) {
      api.createRecord('9c417fbc', component.options)
    } else {
      api.reload('9c417fbc', component.options)
    }
    module.hot.accept("./RegistryEntityProfile.vue?vue&type=template&id=9c417fbc", function () {
      api.rerender('9c417fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryEntityProfile.vue"
export default component.exports